import { render } from "./DeleteTool.vue?vue&type=template&id=96757316&scoped=true&ts=true&lang=pug"
import script from "./DeleteTool.vue?vue&type=script&lang=ts"
export * from "./DeleteTool.vue?vue&type=script&lang=ts"

import "./DeleteTool.vue?vue&type=style&index=0&id=96757316&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96757316"]])

export default __exports__